import { useState, useRef } from 'react'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider.tsx'
import { ProgramYear } from '@/apis/applicant_school_years/requests.ts'

export default function SchoolYearSelector() {
    const [schoolYearOpen, setSchoolYearOpen] = useState(false)
    const dropdownYearRef = useRef<HTMLDivElement>(null)

    const {applicantProgramYears, selectedProgramId, setSelectedProgramId} = useApplicantProgramYears()

    const handleYearProgram = (programYear: ProgramYear) => {
      setSelectedProgramId(programYear.id)
      setSchoolYearOpen(false)
    }

    const selectedProgramYear = applicantProgramYears.find(py => py.id === selectedProgramId)
    if (applicantProgramYears.length === 0) {
      return <div>Loading program years...</div>
    }
    if (applicantProgramYears.length === 1){
      return <></>
    }
    return (
      <div className="relative w-52" ref={dropdownYearRef}>
        <div
          className="flex items-center justify-between w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-5 font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600 text-sm sm:leading-6 cursor-pointer"
          onClick={() => setSchoolYearOpen(!schoolYearOpen)}
        >
        <span>
          {selectedProgramYear ? selectedProgramYear.name : "Select Year"}
        </span>
          <button
            className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
            id="headlessui-combobox-button"
            type="button"
            aria-haspopup="listbox"
            aria-expanded={schoolYearOpen}
            aria-label="Select Year Dropdown"
          >
            <i className="ki-down ki-filled text-lg"></i>
          </button>
        </div>

        {schoolYearOpen && (
          <div className="absolute mt-1 w-full bg-white rounded-t-md shadow-lg ring-1 ring-gray-300 rounded-b-md">
            <hr />
            <div className="p-2 text-gray-500">Years:</div>
            <ul className="max-h-80 overflow-y-auto rounded-b-md">
              {applicantProgramYears.map((programYear) => (
                <li
                  key={programYear.id}
                  className="flex items-center justify-between px-4 py-2 cursor-pointer text-gray-900 hover:bg-primary-600 hover:text-white group text-sm"
                  onClick={() => handleYearProgram(programYear)}
                >
                  <span className="font-semibold">{programYear.name}</span>
                  {selectedProgramId === programYear.id && (
                    <i
                      className="ki-filled ki-check ml-2 text-primary-500 group-hover:text-white"
                      aria-hidden="true"
                    ></i>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )

}